import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';
import { CTA } from '../components/Layout/CTA';

import '../components/GlobalStyle.css';

import ReferralSplash from '../assets/images/Referral - Splash.png';
import ReferralWhy from '../assets/images/Referral - Why.png';
import QR from '../assets/images/Referral - QR Code.png';
import Reporting from '../assets/images/Referral - Claims Report.png';

import { FadeLoad, FadeLoadDelay, FadeScroll } from '../components/styled/Motion.styled';
import { ReferralAccordion } from '../components/ReferralComponents/ReferralAccordions';


const ImageMargin = styled.div`
    @media screen and (min-width: 1200px) {
        margin-top: -8rem;
        z-index: -1;
    }
`

const Referrals = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Programs | Referrals</title>
                <link rel="canonical" href="https://bestpayment.solutions/referrals" />
            </Helmet>
            <Navigation />
            <Container fluid>
                <Row className='vh-75 pt-5 align-items-center justify-content-evenly text-center'>
                    <Col lg={7} md={10}>
                        <FadeLoad>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>Referral Pro</h2>
                            <h1 className='fs-60'>
                                Boost your business with Referral Pro, our powerful referral platform
                            </h1>
                            <p>
                                Referrals are a proven strategy to increase your sales, leads, and brand awareness, while also reducing your expenses. With Best Payment Solutions Referral Pro and support from our team, you’ll be on your way to success!
                            </p>
                        </FadeLoad>
                    </Col>
                    <Col xs={12}>
                        <FadeLoadDelay>
                            <ImageMargin>
                                <img src={ReferralSplash} width='100%' />
                            </ImageMargin>
                        </FadeLoadDelay>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5 bg-cream'>
                <FadeScroll>
                    <Row className="justify-content-evenly align-items-center text-center">
                        <Col lg={5} md={8}>
                            <h3 className='fs-48'>Why referrals?</h3>
                            <p>
                                The data is clear. With all the possible benefits of a referral program, this may be exactly the solution you’ve been looking for.
                            </p>
                        </Col>
                    </Row>
                </FadeScroll>
                <Row className="justify-content-evenly align-items-center pt-5 pt-lg-0">
                    <Col lg={5}>
                        <ReferralAccordion />
                    </Col>
                    <Col lg={5} sm={6}>
                        <FadeScroll>
                            <img src={ReferralWhy} width='100%' />
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5'>
                <Row className="justify-content-evenly align-items-center py-5 text-center">
                    <Col lg={5} md={8}>
                        <h3 className='fs-48'>What you get working with Best Payment Solutions</h3>
                        <p>
                            Our team is dedicated to providing all the tools and resources needed to create, maintain, and grow your referral program.
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} sm={8}>
                        <FadeScroll>
                            <img src={QR} width='100%' />
                        </FadeScroll>
                    </Col>
                    <Col lg={5}>
                        <h5 className='fw-bold pt-4 fs-24'>Multiple opportunities to engage participants & make sales</h5>
                        <p>
                            Our platform enables easy sharing, automated referral tracking, and enticing incentives  This makes referring simple and rewarding for participants.  We’ve made it easy for both dealers and participants to get credited for their referrals. Dealers are given unique QR codes to share with their referrals, while participants receive shareable links for social media. This makes it easy for them to refer people and be automatically credited for their referrals. Your program’s referral site can also include links to discounted products for additional sales opportunities.
                        </p>

                        <h5 className='fw-bold pt-4 fs-24'>Fastest program setup in the industry</h5>
                        <p>
                            At Best Payment Solutions, we pride ourselves on being able to take programs live in less than 60 days. Gone are the days of wading through a lengthy program implementation. We have perfected our techniques and strategies to provide you with top-quality programs with a lightning-fast turn-around time.
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} className='order-2 order-lg-1'>
                        <h5 className='fw-bold pt-4 fs-24'>Transparent reporting & analytics</h5>
                        <p>
                            No one wants to spend hours digging through data to try and find what they are looking for. We believe transparent, easily accessible data and reporting are essential. Our programs come with Ad Hoc reporting that can be easily filtered, reviewed, and downloaded right from your admin portal.
                        </p>

                        <h5 className='fw-bold pt-4 fs-24'>Effective communication & connection</h5>
                        <p>
                            Leverage our targeted communication tools to reach participants effectively, driving higher engagement and better conversion rates. With easy access to email automation and a top-notch customer service team, both you and your participants will never be in the dark.
                        </p>

                        <h5 className='fw-bold pt-4 fs-24'>White-label sites that highlight your brand’s identity</h5>
                        <p>
                            Maintain your brand’s identity even with white-label solutions. We work with you to customize your incentive platform to perfectly reflect your brand’s identity, enhancing recognition and loyalty. Once live, our referral programs platform comes with an easy uploader. This allows you to change headlines, program duration, copy, and more!
                        </p>
                    </Col>
                    <Col lg={5} md={8} className='order-1 order-lg-2'>
                        <FadeScroll>
                            <img src={Reporting} width='100%' />
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='bg-sky-tint-3 py-5'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default Referrals;